import React, { useState } from 'react'
import { useAuth } from './AuthContext'
import PasswordInput from '../components/ui/PasswordInput'

const IconX = ({size=20,className=""}) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>

export default function LoginScreen() {
  const { signIn } = useAuth()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    setLoading(true)
    try {
      await signIn(email, password)
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-white tracking-wide">BEATY</h1>
          <p className="text-slate-400 mt-1">Brothers Moving System</p>
        </div>
        <div className="bg-white rounded-xl shadow-xl p-8">
          <h2 className="text-xl font-bold text-slate-900 mb-6">Sign In</h2>
          {error && <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">{error}</div>}
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label className="block text-sm font-medium text-slate-700 mb-1">Email</label>
              <input type="email" required value={email} onChange={e => setEmail(e.target.value)} className="w-full border border-slate-300 rounded-lg px-3 py-3 text-base focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent" placeholder="you@beatybrothers.com" />
            </div>
            <div className="mb-6">
              <label className="block text-sm font-medium text-slate-700 mb-1">Password</label>
              <PasswordInput required minLength="6" value={password} onChange={e => setPassword(e.target.value)} className="w-full border border-slate-300 rounded-lg px-3 py-3 text-base focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent" placeholder="Enter password" />
            </div>
            <button type="submit" disabled={loading} className="w-full bg-red-600 hover:bg-red-700 text-white py-3 rounded-lg text-base font-semibold disabled:opacity-50">
              {loading ? 'Please wait...' : 'Sign In'}
            </button>
          </form>
          <p className="mt-4 text-center text-xs text-slate-400">Access is invite-only. Contact your admin if you need an account.</p>
        </div>
        <p className="text-center text-slate-500 text-xs mt-6">Beaty Brothers Moving • Nashville, TN</p>
      </div>
    </div>
  )
}
